import React, { useEffect } from 'react';
import GoogleMap from 'google-map-react';
import CustomMarker from "./CustomMarker";
import MapModal from "./MapModal";
import FilterControls from "./FilterControls";
import IslandModal from "./IslandModal";
import IslandMarker from "./IslandMarker";

const Map = (props) => {
    const {
        updateSelection,
        updateZoomCenter,
        islandData,
        updateStatus,
        updateIsland,
        query,
        status,
        island,
        viewType,
        center,
        zoom,
        selection,
        locations,
        categories
    } = props;

    const _onChildClick = (key, childProps) => {
        updateSelection(childProps.id);
    };

    useEffect(() => {
        // Focus on island when island data becomes available
        if (islandData && islandData.lat && islandData.lng) {
            updateZoomCenter(
                { lat: parseFloat(islandData.coords.coordinates[1]), lng: parseFloat(islandData.coords.coordinates[0]) },
                17 // Zoom level appropriate for island view
            );
        }
    }, [islandData, updateZoomCenter]);

    return (
        <div className="fullscreen-map">
            <div className="w-100 h-100">
                <div className="position-relative">
                    <FilterControls
                        updateStatus={updateStatus}
                        updateIsland={updateIsland}
                        requery={() => query()}
                        currentStatus={status}
                        currentIsland={island}
                        viewType={viewType}
                    />

                    {islandData && (
                        <IslandModal
                            island={islandData}
                            updateIsland={updateIsland}
                        />
                    )}
                </div>
                <GoogleMap
                    bootstrapURLKeys={{
                        key: window.Laravel.apiKey,
                        language: $('html').attr('lang')
                    }}
                    defaultZoom={10}
                    center={center}
                    // defaultCenter={{lat: 4.175804, lng: 73.509337}}
                    zoom={zoom}
                    yesIWantToUseGoogleMapApiInternals
                    onChange={(params) => {
                        updateZoomCenter(params.center, params.zoom);
                        query(params.bounds);
                    }}
                    onClick={() => {
                        if(selection) {
                            updateSelection(null);
                        }
                    }}
                    hoverDistance={20}
                    onChildClick={_onChildClick}
                    options={{
                        fullscreenControl: false
                    }}
                >
                    {
                        locations.map((location, key) => {
                            return <CustomMarker
                                categories={categories}
                                key={key}
                                id={location.id}
                                name={location.title}
                                lat={location.lat}
                                lng={location.lng}
                                category={location.categories? location.categories[0] : null}
                                selected={selection ? selection.id === location.id : false}
                            />
                        })
                    }
                    {islandData && (
                        <IslandMarker
                            lat={parseFloat(islandData.coords.coordinates[1])}
                            lng={parseFloat(islandData.coords.coordinates[0])}
                        />
                    )}
                </GoogleMap>
            </div>
        </div>
    );
};

export default Map;
